<template>
      <v-container>
        <v-card
        class="mx-auto">
          <v-toolbar flat color="secondary">
              <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="btnAdd" type="button"><v-icon left>{{icon.add}}</v-icon>Tambah</v-btn>
          </v-toolbar>

          <v-card-text>
              <v-data-table
              :headers="headers"
              :options.sync="options"
              :items="dataList"
              :server-items-length="total_data"
              :loading="data_loading"
              :search="search"
              class="elevation-1"
              dense
              >
              <template v-slot:top>
              <v-toolbar flat color="white">
                <v-dialog>
              <template v-slot:activator="{ on }">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field v-model="search"
                    label="Search"
                    single-line
                    hide-details
                    v-on:keyup.enter="searchItem()"
                    @blur="searchItem()"></v-text-field>
                  </v-col>
                </v-row>
              </template>
              </v-dialog>
                </v-toolbar>
              </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    {{icon.edit}}
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteItem(item)"
                  >
                    {{icon.delete}}
                  </v-icon>
                </template>
                <template v-slot:item.status="{ item }">
                    <v-btn v-if="item.active" class="ma-2" color="success" x-small dark>Active
                    <v-icon dark right>mdi-checkbox-marked-circle</v-icon>
                    </v-btn>

                    <v-btn v-else class="ma-2" color="" x-small >Disabled
                    <v-icon dark right>mdi-cancel</v-icon>
                    </v-btn>
                </template>
              </v-data-table> 
          </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
   let context;
   export default{
    name:"vendor.index",
    data: ()=>{
      return {
        icon:{
          add:'mdi-plus',
          edit:'mdi-pencil',
          delete:'mdi-delete'
        },
        search:"",
        total_data: 0,
        options: {
                itemsPerPage: 10,
                page:1
            },
        dataList: [],
        data_loading: false,
        headers: [
          { text: 'Nama Vendor', value: 'name'},
          { text: 'Email', value: 'email', align:'left'},
          { text: 'Phone', value: 'phone'},
          { text: 'Fax', value: 'fax', sortable:false},
          { text: 'Active', value: 'active', sortable:false},
          { text: 'Created', value: 'created_at', align:'center' },
          { text: 'Actions', value: "action" ,sortable:false},
        ],
      }
    },
    watch: {
      datas: [],
      options: {
        handler () {
         context.getData();
        },
        deep: true,
      },
    },
    created: function () {
    },
    async mounted () {
      try{
        context=this;
        context.search=context.$route.query.search;
        await this.getData();

      }catch{
        
      }
    },
    methods: {
      getData () {
        context.data_loading=true;
        this.$http.get('vendor/table',{
          params:{
            item:context.options.itemsPerPage,
            page:context.options.page,
            q:context.search,
            sort_by:JSON.stringify(context.options.sortBy),
            sort_desc:JSON.stringify(context.options.sortDesc)
          },
        }).then(({data,status})=>{
            if(status===200){
              context.dataList=data.data.data;
              this.total_data = data.data.total;
            }
            context.data_loading=false;
          }
        )
        .catch(error=>{
          context.data_loading=false;
        });
      },

      editItem:(item)=>{
        context.$router.push('/'+context.$route.meta.parent+'/edit/'+item.id);
      },

      deleteItem:async (item)=>{
        let conf=confirm("Apakah anda yakin akan menghapus "+item.name+" dari database?");
        let index=context.dataList.indexOf(item);

        if(conf){
          let payload={
            id:item.id
          }
          let success_text="Berhasil menghapus "+item.name+" dari database";
          await context.$http
          .delete('category/delete',{data:payload})
          .then(response=>{
              if(response.status===200){
                  context.$notify({
                      group:"success",
                      title:"Success Notification",
                      text:success_text
                  })
                context.dataList.splice(index,1);
              }
          })
          .catch(err=>{
                context.$notify({
                        group:"error",
                        title:"Error Notification",
                        text:"Terjadi kesalahan pada client"
                })
            });
        }
      },
      searchItem(){
        try{
          if(context.search!=context.$route.query.search){
            context.$router.push({
              query:{
                search:context.search,
                sort:JSON.stringify(context.sort_by),
                sort:JSON.stringify(context.sort_desc)
              }
            })  
            context.getData();
          }else{
            
          }
        }catch (err){
          
        }
      },

      btnAdd () {
        this.$router.push('/'+context.$route.meta.parent+'/add')
      }
    },
}
</script>